import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { images } from "../assets/images";
import { BackgroundMedia } from "./BackgroundMedia";

export function StatisticsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      id="war-harm"
      ref={ref}
      className="relative h-screen w-full flex items-end justify-start overflow-hidden"
    >
      {/* 背景图片 */}
      <div className="absolute inset-0">
        <BackgroundMedia
          videoSrc={images.stats}
          imageSrc={images.statsImage}
          className="w-full h-full object-cover object-center"
        />
        {/* 深色遮罩层确保文字清晰可见 */}
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Main Content - 左下角 */}
      <div className="relative z-10 pb-24 px-8 md:px-12 max-w-7xl w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 1, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="mb-4">
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
              transition={{ duration: 1.2, delay: 0.7 }}
              className="text-white leading-none flex items-baseline gap-2"
            >
              <span className="text-8xl md:text-9xl lg:text-[12rem]">4.73</span>
              <span className="text-4xl md:text-5xl lg:text-6xl">亿</span>
            </motion.div>
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.8, delay: 1.2 }}
          >
            <p className="text-white text-xl md:text-3xl lg:text-4xl tracking-wide">
              童年被困无尽的硝烟中
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

